import {Stack, Box, Transition, ActionIcon} from "@mantine/core";
import IconArrowDown from "../../../assets/arrow-down.svg?react";
import {CommandInput} from "../components/CommandInput";
import classes from "./ChatInput.module.css";
import {SubmitWithAttachments} from "../utils/pasteAttachments";
import React from "react";

type ChatInputProps = {
    disabled: boolean;
    onSubmit: SubmitWithAttachments;
    showScrollDownButton: boolean;
    scrollRef: React.RefObject<HTMLDivElement | null>;
};

export const ChatInput = ({
    disabled,
    onSubmit,
    showScrollDownButton,
    scrollRef,
}: ChatInputProps) => {
    return (
        <Stack
            gap={0}
            className={classes.inputContainer}
            data-name="chat-input"
        >
            <Box pos="relative">
                <Transition
                    transition="slide-up"
                    mounted={showScrollDownButton}
                >
                    {(transitionStyles) => (
                        <Box
                            style={{
                                ...transitionStyles,
                                position: "absolute",
                                bottom: "calc(100% + 0.5rem)",
                                left: "50%",
                                transform: "translateX(-50%)",
                                zIndex: 2,
                            }}
                        >
                            <ActionIcon
                                variant="filled"
                                color="gneis.0"
                                c="dark.6"
                                bd={"1px solid white"}
                                radius="xl"
                                size="lg"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                    const el = scrollRef.current;
                                    if (!el) return;
                                    if (
                                        !window.matchMedia("(pointer: coarse)")
                                            .matches
                                    ) {
                                        el.scrollTo({
                                            top: el.scrollHeight,
                                            behavior: "smooth",
                                        });
                                        return;
                                    }
                                    const previous = el.style.scrollBehavior;
                                    el.style.scrollBehavior = "auto";
                                    el.scrollTop = el.scrollHeight;
                                    el.style.scrollBehavior = previous;
                                }}
                            >
                                <IconArrowDown height={18} />
                            </ActionIcon>
                        </Box>
                    )}
                </Transition>
                <CommandInput
                    variant="chat"
                    disabled={disabled}
                    onSendMessage={onSubmit}
                />
            </Box>
        </Stack>
    );
};
